export { default } from "./Acquiring";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/Acquiring/index.js